import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ProductProperty } from '@getaccept/lib-shared/src/product-library/product-properties/types/product-property';
import { useLoadAllProductProperties } from '@getaccept/lib-shared/src/product-library/product-properties/composables/load-all-product-properties.composable';

export const useProductPropertiesStore = defineStore('product-properties', () => {
  const productProperties = ref<ProductProperty[]>([]);

  const {
    loadAll: load,
    loading,
    loaded,
    reset: resetComposableState,
  } = useLoadAllProductProperties({
    onSuccess: data => (productProperties.value = data.productProperties),
  });

  const reset = () => {
    resetComposableState();
    productProperties.value = [];
  };

  return {
    productProperties,
    load,
    loading,
    loaded,
    reset,
  };
});
